import React from 'react'
import { Icon } from '../Icon'
import { SectionProps, SectionHeaderProps } from './Section.types'
import { StyledSection, StyledSectionHeader } from './Section.styles'

export const Section: React.FC<SectionProps> = ({
  children,
  spacing = 'xlarge',
  className,
}) => {
  return (
    <StyledSection $spacing={spacing} className={className}>
      {children}
    </StyledSection>
  )
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  children,
  icon,
  className,
}) => {
  return (
    <StyledSectionHeader className={className}>
      {icon && <Icon name={icon} size="small" />}
      {children}
    </StyledSectionHeader>
  )
}
